//
// Copyright 2020 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
var styles = function styles(theme) {
  return {
    company: {
      color: theme.palette.primary.main
    },
    caption: {
      color: theme.palette.text.secondary
    }
  };
};
function Copyright(_ref) {
  var classes = _ref.classes,
    years = _ref.years;
  return /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexDirection: "row"
  }, /*#__PURE__*/React.createElement(Box, {
    p: 0.5
  }, /*#__PURE__*/React.createElement("img", {
    src: "static/images/footerCompanyLogo.gif",
    title: "Logo",
    alt: "Logo",
    width: "auto"
  })), /*#__PURE__*/React.createElement(Box, {
    p: 0.5
  }, /*#__PURE__*/React.createElement(Typography, {
    noWrap: true,
    variant: "caption",
    color: "textSecondary"
  }, "©", years || new Date().getFullYear())), /*#__PURE__*/React.createElement(Box, {
    p: 0.5
  }, /*#__PURE__*/React.createElement(Typography, {
    noWrap: true,
    variant: "caption",
    className: classes.company
  }, "Emerald Associates")), /*#__PURE__*/React.createElement(Box, {
    p: 0.5
  }, /*#__PURE__*/React.createElement(Typography, {
    noWrap: true,
    variant: "caption",
    className: classes.caption
  }, "All Rights Reserved")));
}
export default withStyles(styles)(Copyright);